import { Messages } from "../../lib/locale";

export const Portuguese: Messages = {
  name: "Portuguese",
  helpTitle: "Como jogar",
  help1: `Sua tarefa é descobrir qual país está escondido no jogo. Para fazer isso, você precisa inserir os nomes dos países aleatórios. Escreva o país na caixa de entrada e pressione Enter. Este país aparecerá no mapa e mudará de cor dependendo da proximidade do país oculto. Quanto mais escura a cor, mais perto você está da resposta!`,
  help2: `Veja o exemplo do jogo. Digamos que o país Japão está escondido no jogo. Então esses países serão pintados com essas cores.`,
  help3: `Uma vez por dia, um novo país oculto está disponível. Ou mude para o modo livre nas configurações e jogue sem limites.`,
  France: "França",
  Nepal: "Nepal",
  Mongolia: "Mongólia",
  "South Korea": "Coreia do Sul",
  Aux1: `<b>["Clique", "Toque"]</b> no globo para começar!`,
  Loading: "Espere por isso...",
  GameTitle: "Jogo",
  Game1: "Digite o nome do país aqui",
  Game2: "Inserir",
  Game3: "Insira o nome de qualquer país para fazer sua primeira tentativa.",
  Game4: `Gire, <span>["clique", "toque"]</span> e amplie o globo para encontrar o próximo país para adivinhar`,
  Game5: "Não conhecemos este país",
  Game6: "Este país já está inserido",
  Game7: "O país misterioso é {answer}!",
  Game8: "Borda mais próxima",
  StatsTitle: "Estatisticas",
  Stats1: "Última vitória",
  Stats2: "Palpites de hoje",
  Stats3: "Jogos vencidos",
  Stats4: "Sequência atual",
  Stats5: "Sequência máxima",
  Stats6: "Estimativas médias",
  Stats7: "Estimativas médias",
  Stats8: "Redefinir",
  Stats9: "Compartilhar",
  Stats10: "Tem certeza de que deseja redefinir sua pontuação?",
  Stats11: "Estatísticas apagadas.",
  Stats12: "Copiado para a área de transferência!",
  SettingsTitle: "Definições",
  Settings1: "Tema do dia",
  Settings2: "Tema noturno",
  Settings3: "Modo daltônico",
  Settings4: "Modo daltônico",
  Settings5: "Países",
  Settings7: "Linguagem",
  Settings9: "Modo livre",
  Settings10: "Dica",
  Answer: "Responda",
  Closest: "Mais próximo",
  Guessed: "Adivinhado",
  PracticeMode: "Você está no modo livre.",
  PracticeExit: "Sair do modo livre",
  PracticeNew: "Novo jogo grátis",
  PlayAgain: "Jogar de novo",
  SortBy: "Classificar por:",
  SortByGuesses: "ordem de adivinhação",
  SortByDistance: "distância",
  Clipboard: "🌍🌍🌍\nEu adivinhei o país escondido no Globle de hoje em {X} palpites\nVocê pode fazê-lo melhor?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Vitória",
  Guesses: "Suposições",
  GuessesFlags: "Seus palpites estarão aqui",
  Daily: "Diario",
  NextDailyIn: "Próximo Diariamente",
  Learn: "Saiba mais sobre este país"
};